var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZlinkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-App_Icon_-_512_X_512_Android_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App_Icon_-_512_X_512_Android_4",
    "data-name": "App Icon - 512 X 512 \\u2013 Android \\u2013 4",
    clipPath: "url(#clip-App_Icon_-_512_X_512_Android_4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ZKBio_Zlink_-3_-_App_Icon",
    "data-name": "ZKBio Zlink -3 - App Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6112",
    "data-name": "Rectangle 6112",
    d: "M0,0H512a0,0,0,0,1,0,0V206a50,50,0,0,1-50,50H50A50,50,0,0,1,0,206V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 256)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6111",
    "data-name": "Rectangle 6111",
    d: "M50,0H462a50,50,0,0,1,50,50V256a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V50A50,50,0,0,1,50,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(67.012 71.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(240.059 10.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M497,330.816V251.9h23.173c6.941,0,12.441,1.655,16.606,4.966a15.935,15.935,0,0,1,6.194,13.188,19.056,19.056,0,0,1-3.684,11.533,20.021,20.021,0,0,1-10.145,7.1v.214a19.826,19.826,0,0,1,12.868,6.087,18.526,18.526,0,0,1,4.805,13.135,20.833,20.833,0,0,1-7.315,16.5c-4.859,4.218-11.106,6.3-18.688,6.3H497Zm10.2-70v24.721h9.291c4.912,0,8.81-1.175,11.586-3.577a12.48,12.48,0,0,0,4.218-9.931c0-7.422-4.966-11.159-14.844-11.159H507.2Zm0,33.585v27.5h12.227q8.009,0,12.334-3.684c2.883-2.456,4.378-5.873,4.378-10.252,0-9.024-6.14-13.562-18.367-13.562Z",
    transform: "translate(-497 -248.376)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M609.1,251.547a5.879,5.879,0,0,1,1.815-4.432,5.961,5.961,0,0,1,4.432-1.815,6.285,6.285,0,0,1,4.538,1.762,5.96,5.96,0,0,1,1.869,4.485,5.728,5.728,0,0,1-1.869,4.378,6.374,6.374,0,0,1-4.538,1.762,6.075,6.075,0,0,1-4.485-1.762A5.833,5.833,0,0,1,609.1,251.547Zm1.175,76.193V271.41h9.985V327.74Z",
    transform: "translate(-549.245 -245.3)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M650.4,321.861c0-9.29,2.616-16.659,7.8-22,5.179-5.393,12.227-8.062,21.144-8.062,8.436,0,15.057,2.563,19.862,7.742s7.208,12.334,7.208,21.464c0,8.917-2.563,16.072-7.689,21.518s-12.013,8.223-20.61,8.223c-8.436,0-15.164-2.67-20.183-7.956S650.4,330.51,650.4,321.861Zm10.2-.32c0,6.461,1.655,11.586,4.912,15.324s7.689,5.606,13.188,5.606c5.713,0,10.038-1.815,13.028-5.5q4.485-5.446,4.485-15.7c0-6.834-1.495-12.12-4.485-15.8s-7.315-5.5-13.028-5.5c-5.606,0-10.038,1.922-13.242,5.767C662.2,309.58,660.6,314.866,660.6,321.54Z",
    transform: "translate(-568.494 -266.972)",
    fill: "#76b745"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_631_",
    transform: "translate(104.438 14.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M353.686,330.368H369.6l-33.1-40.1.267-.267-.214-.214L367.248,253H352.671L327.9,284.449l-3.791,3.738V253h-11.96v67.17h-9.718v-.053H260.033l43.036-62.257V253H246.417V263.3h39.725L243,325.188v5.179h81.105V302.656l4.378-4.378Z",
    transform: "translate(-243 -253)",
    fill: "#474b4f",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_621_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M92.731,338.627l-2.189-.961c-11.213-4.645-37.8-18.047-42.982-41.754h0a18.847,18.847,0,0,1-.16-3.364V266.332c0-14.149.053-28.406.053-28.566v-3.631L92.838,226.5l44.8,7.849V294.9c.214,1.762.16,6.674-4.592,13.615-6.621,9.718-19.6,19.542-38.5,29.153ZM55.943,294.47c2.029,8.97,8.329,17.3,18.634,24.775a93.148,93.148,0,0,0,17.78,9.985c35.881-18.634,36.735-31.93,36.735-33.211l-.16-.534.107-.214V241.61l-36.254-6.354L56,241.45C55.943,262.381,55.89,291,55.943,294.47Zm73.2,1.655ZM55.89,294.1v0Z",
    transform: "translate(-47.4 -226.5)",
    fill: "#76b745"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_623_",
    transform: "translate(33.852 20.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M121.586,287.178A10.839,10.839,0,1,0,110.8,276.339,10.813,10.813,0,0,0,121.586,287.178Zm-.32,45.972,11-42.288h-20.93Z",
    transform: "translate(-110.8 -265.5)",
    fill: "#76b745",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(86 326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_326",
    "data-name": "Union 326",
    d: "M11022.194,13997.44l-24.4-35.153-8.206,8.428v26.726h-18.411V13881h18.411v67.2l5.765-7.205,22.623-25.507h22.181l-30.5,34.156,33.713,47.8Zm-71.421-.112h0Zm-17.519,0v-43.693c0-14.525-5.1-21.734-15.415-21.734a17.061,17.061,0,0,0-13.311,5.99c-3.548,3.99-5.209,9.091-5.209,15.192v44.245h-17.635V13919.7h17.635v12.864h.333c5.765-9.763,14.192-14.751,25.17-14.751,8.432,0,14.863,2.771,19.3,8.206s6.653,13.419,6.653,23.729v47.575Zm-92.045,0V13919.7h17.635v77.624Zm-36.521,0v-108.679h18.077v93.485h.011v15.193Zm-101.691,0v-8.314l59.775-85.171h-55.226v-15.3h80.178v7.984h.109l-59.551,85.609h58.774v15.193Zm139.655-96.7a9.387,9.387,0,0,1-3.105-7.1,9.244,9.244,0,0,1,3.105-7.209,11.154,11.154,0,0,1,14.969,0,9.244,9.244,0,0,1,3.105,7.209,8.943,8.943,0,0,1-3.105,6.983,11.32,11.32,0,0,1-14.969.112Z",
    transform: "translate(-10702.999 -13881)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZlinkLogo);
export default __webpack_public_path__ + "static/media/zlink_logo.42fa65ea96ff32fee902bb5c7284a6b5.svg";
export { ForwardRef as ReactComponent };